import { ResponseService } from './../services/response.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from './../services/api.service';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { devModeEqual } from '@angular/core/src/change_detection/change_detection';


@Component({
    selector: 'app-backupftp-dashboard',
    templateUrl: './backupftp-dashboard.component.html'
})

export class BackupftpDashboardComponent implements OnInit {

    // Zmienna mówiąca o pobieraniu danych
    public loadingBackupFtpData: Boolean = true;
    public backupFtpIsReady: Boolean = false;

    // Obiekt backup FTP
    public backupftp: any;
    public ftpAccounts: any;
    public shellAccounts: any;
    public uuid: String;
    public accountLogin: any;
    public accountPassword: any;
    public isLoadingAccountData: boolean;
    public accountPubKey: String;
    public hasPubKey: boolean;

    ftpAccountForm: FormGroup;
    shellAccountForm: FormGroup;
    backupFtpForm: FormGroup;


    /**
     * Creates an instance of ServerDashboardComponent.
     * @param {ApiService} apiService 
     * @param {ActivatedRoute} router 
     * 
     * @memberOf BackupftpDashboardComponent
     */
    constructor(
        private apiService: ApiService,
        private responseService: ResponseService,
        private route: ActivatedRoute,
        private breadcrumbService: BreadcrumbService,

        private router: Router
    ) {
    }



    /**
     * Funkcja inicjalizujaca
     * 
     * 
     * @memberOf BackupftpDashboardComponent
     */
    ngOnInit() {
        this.isLoadingAccountData = true;
        this.accountPubKey = null;
        this.hasPubKey = false;
        this.route.params.subscribe(params => {
            this.uuid = String(params['uuid']);
            this.getBackupFtpInfo(this.uuid);
        });

        let ftpUsername = new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(16)]);
        let ftpPassword = new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(16)]);
    
        this.ftpAccountForm = new FormGroup({
          username: ftpUsername,
          password: ftpPassword,
        });

        let shellUsername = new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(16)]);
        let shellPassword = new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(16)]);
        let shellPubKey = new FormControl('', []);
    
        this.shellAccountForm = new FormGroup({
          username: shellUsername,
          password: shellPassword,
          pubkey: shellPubKey
        });
        let backupFtpName = new FormControl('', [Validators.required]);

        this.backupFtpForm = new FormGroup({
            name: backupFtpName,
        });
    }

	formatBytes(a, b, c) { if (0 == a) return "0 Bytes"; var c = c || 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], f = Math.floor(Math.log(a) / Math.log(c)); return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f] }


    private getBackupFtpInfo(uuid: String): void {
        this.loadingBackupFtpData = true;
        this.apiService.get('/backup-ftp/' + uuid).subscribe(
            (response) => {
                const backupftp = this.responseService.success(false, response, 'backup-ftp');
                this.shellAccounts = this.responseService.success(false, response, 'shell-accounts');
                this.ftpAccounts = this.responseService.success(false, response, 'ftp-accounts');
                this.backupftp = backupftp;
                this.backupFtpIsReady = this.backupftp.active;
                if(this.backupFtpIsReady){
                    this.breadcrumbService.addFriendlyNameForRoute('/backupftp/' + uuid, backupftp.name);
                }
                this.loadingBackupFtpData = false;
            },
            (error) => {
                this.responseService.error(error);
            }
        );
    }

    /**
   * Pobranie hasła konta FTP
   * 
   * @private
   * @param {*} modal 
   * @memberof BackupftpDashboardComponent
   */
	private showFtpPassword(modal: any, ftpAccount: any): void {
        this.isLoadingAccountData = true;
        this.accountPassword = '';
        this.accountLogin = ftpAccount.username;
        this.accountPubKey  = null;
        this.hasPubKey = false;
        this.apiService.get('/backup-ftp/' + this.uuid + '/ftp-account/' + ftpAccount.uuid + '/password').subscribe(
            (response) => {
                this.accountPassword = this.responseService.success(false, response, 'password');
                this.isLoadingAccountData = false;
            },
            (error) => {
                this.responseService.error(error);
            }
        );
		modal.open();
	}

      /**
   * Pobranie hasła konta FTP
   * 
   * @private
   * @param {*} modal 
   * @memberof BackupftpDashboardComponent
   */
	private showShellPassword(modal: any, ftpAccount: any): void {
        this.isLoadingAccountData = true;
        this.accountPassword = '';
        this.accountLogin = ftpAccount.username;
        this.apiService.get('/backup-ftp/' + this.uuid + '/shell-account/' + ftpAccount.uuid + '/password').subscribe(
            (response) => {
                this.accountPassword = this.responseService.success(false, response, 'password');
                this.accountPubKey = this.responseService.success(false, response, 'pubkey');
                this.hasPubKey = this.accountPubKey == null ? false : true;
                this.isLoadingAccountData = false;
            },
            (error) => {
                this.responseService.error(error);
            }
        );
		modal.open();
    }
    
    private addFtpAccount(modal: any): void {
        modal.open();
    }

    private addShellAccount(modal: any): void {
        modal.open();
    }

    private changeName(modal: any): void {
        modal.open();
    }

    private setName(modal:any): void {
        this.apiService.put('/backup-ftp/' + this.uuid, this.backupFtpForm.value).subscribe(
            (response) => {
                this.responseService.success(true, response, false);
                modal.close();
                location.reload();
            },
            (error) => {
                this.responseService.error(error);
            }
        );
    }

    generateRandom(length: any): String {
        let possible = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
        let text = "";
        for (let i = 0; i < length; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }
    private getNewFtpUsername():void {
        this.ftpAccountForm.controls['username'].patchValue(this.generateRandom(16));
    }

    private getNewFtpPassword():void {
        this.ftpAccountForm.controls['password'].patchValue(this.generateRandom(16));
    }

    private getNewShellUsername():void {
        this.shellAccountForm.controls['username'].patchValue(this.generateRandom(16));
    }

    private getNewShellPassword():void {
        this.shellAccountForm.controls['password'].patchValue(this.generateRandom(16));
    }

    createFtpAccount(modal: any){
        this.apiService.post('/backup-ftp/' + this.uuid + '/ftp-account', this.ftpAccountForm.value).subscribe(
            (response) => {
                this.responseService.success(true, response, false);
                this.ftpAccountForm.reset();
                modal.close();
                location.reload();
            },
            (error) => {
                this.responseService.error(error, this.ftpAccountForm);
            }
        );
    }

    createShellAccount(modal: any){
        this.apiService.post('/backup-ftp/' + this.uuid + '/shell-account', this.shellAccountForm.value).subscribe(
            (response) => {
                this.responseService.success(true, response, false);
                this.shellAccountForm.reset();
                modal.close();
                location.reload();
            },
            (error) => {
                this.responseService.error(error, this.shellAccountForm);
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/backupftp/backupftp-dashboard.component.ts